'use client'
import React, { useEffect, useState } from 'react'
import {
  Box,
  Button,
  Flex,
  Image,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Text,
  useBreakpointValue,
} from '@chakra-ui/react'

export default function EarningAds({
  isOpen,
  onClose,
}: {
  isOpen: boolean
  onClose: () => void
}) {
  const [mobileModalOpen, setMobileModalOpen] = useState(isOpen)
  const [modalLargeOpen, setModalLargeOpen] = useState(isOpen)

  const isMobile = useBreakpointValue({ base: true, sm: false })

  const handleCloseLargeModal = () => {
    setModalLargeOpen(false)
    onClose()
  }

  const handleCloseMobileModal = () => {
    setMobileModalOpen(false)
    onClose()
  }

  useEffect(() => {
    if (isMobile) {
      setMobileModalOpen(isOpen)
      setModalLargeOpen(false)
    } else {
      setModalLargeOpen(isOpen)
      setMobileModalOpen(false)
    }
  }, [isMobile, isOpen])

  return (
    <>
      <Modal
        isOpen={modalLargeOpen}
        onClose={handleCloseLargeModal}
        isCentered
        size={'2xl'}
      >
        <ModalOverlay />
        <ModalContent mx={18} borderRadius={'16px !important'}>
          <ModalHeader
            py={5}
            className="flex items-center justify-between border-b-2 border-b-[#9F9F9F30] px-4"
          >
            <Text className="text-[18px] text-[#727272]">
              {/* Earnings are based on ads */}
              Watch Time Earnings are based on ads
            </Text>{' '}
            <ModalCloseButton
              color={'#656565'}
              position={'unset'}
              fontSize={14}
            />
          </ModalHeader>
          <ModalBody p={0} borderTopRadius={28}>
            <Flex className="mt-5 flex-col justify-center px-4">
              <Text className="text-center text-sm font-semibold text-[#797979]">
                Ad Revenue of a video vs Time in Days
              </Text>

              <Image
                src={'/rewards/LineChart.svg'}
                alt="Icon"
                w={'100%'}
                h={'100px'}
                my={3}
              />

              <Text className="text-center text-[16px] text-[#656565]">
                {/* <span className="font-bold">Earnings</span> are based on the{' '} */}
                <span className="font-bold">Watch Time Earnings</span> are based on the{' '}
                <span className="font-bold">ad revenue</span> generated by the
                video, so they may not necessarily increase consistently.
              </Text>

              <Flex className="my-4 justify-center gap-3">
                <Flex
                  bg="#ED837F"
                  className="items-center justify-center rounded-md"
                  color={'white'}
                  fontWeight={400}
                  _hover={{
                    backgroundColor: '#ED837F',
                    color: 'white',
                  }}
                  px={4}
                  py={1}
                >
                  {' '}
                  <Image
                    src={'/rewards/arrow-clockwise.svg'}
                    alt="Icon"
                    boxSize={4}
                    mr={1}
                  />
                  Reload Video
                </Flex>

                <Flex
                  bg="#ED837F"
                  className="items-center justify-center rounded-md"
                  color={'white'}
                  fontWeight={400}
                  _hover={{
                    backgroundColor: '#ED837F',
                    color: 'white',
                  }}
                  py={1}
                  px={4}
                >
                  {' '}
                  Skip Ad
                  <Image
                    src={'/rewards/playbtn.svg'}
                    alt="Icon"
                    boxSize={3}
                    ml={1}
                  />
                </Flex>
              </Flex>

              <Image
                src="/rewards/compare.svg"
                alt="compare"
                boxSize={{ base: 4, sm: 5 }}
                alignSelf={'center'}
              />

              <Text className="my-3 text-center text-2xl font-semibold text-[#656565]">
                $0.00
              </Text>
              <Text className="mb-20 text-center text-[16px] text-[#656565]">
                Keep in mind, if you <span className="font-bold">skip ads</span>{' '}
                or <span className="font-bold">replay videos</span>, that
                watchtime will <span className="font-bold">not be counted</span>{' '}
                towards your Watch Time Earnings.
              </Text>
            </Flex>

            <Flex className="absolute bottom-[4%] w-full flex-col gap-3 px-4">
              <Button
                className="w-full py-2 font-semibold"
                color={'white'}
                bg={'lyk-green'}
                border="2px solid white"
                _hover={{
                  border: '2px solid white',
                }}
                onClick={handleCloseLargeModal}
              >
                Go Back
              </Button>
            </Flex>
          </ModalBody>
        </ModalContent>
      </Modal>

      {/* MOBILE VIEW */}
      <Box>
        <Modal
          isCentered={false}
          onClose={handleCloseMobileModal}
          isOpen={mobileModalOpen}
          motionPreset="slideInBottom"
        >
          <ModalOverlay />
          <ModalContent
            borderTopRadius={28}
            position="fixed"
            pb={84}
            bottom="0"
            margin="0 auto"
            width="100%"
            maxWidth="600px"
            display={{ base: 'block', sm: 'none' }}
          >
            <ModalHeader
              py={5}
              className="flex items-center justify-between border-b-2 border-b-[#9F9F9F30] px-4"
            >
              <Text className="text-[18px] text-[#727272]">
                {/* Earnings are based on ads */}
                Watch Time Earnings are based on ads
              </Text>{' '}
              <ModalCloseButton
                color={'#656565'}
                position={'unset'}
                fontSize={14}
              />
            </ModalHeader>
            <ModalBody p={0} borderTopRadius={28}>
              <Flex className="mt-5 flex-col justify-center px-4">
                <Text className="text-center text-sm font-semibold text-[#797979]">
                  Ad Revenue of a video vs Time in Days
                </Text>

                <Image
                  src={'/rewards/LineChart.svg'}
                  alt="Icon"
                  w={'100%'}
                  h={'100px'}
                  my={4}
                />

                <Text className="text-center text-[16px] text-[#656565]">
                  {/* <span className="font-bold">Earnings</span> are based on the{' '} */}
                  <span className="font-bold">Watch Time Earnings</span> are based on the{' '}
                  <span className="font-bold">ad revenue</span> generated by the
                  video, so they may not necessarily increase consistently.
                </Text>

                <Flex className="my-4 justify-center gap-3">
                  <Flex
                    bg="#ED837F"
                    className="items-center justify-center rounded-md"
                    color={'white'}
                    fontWeight={400}
                    _hover={{
                      backgroundColor: '#ED837F',
                      color: 'white',
                    }}
                    py={1}
                    px={4}
                  >
                    {' '}
                    <Image
                      src={'/rewards/arrow-clockwise.svg'}
                      alt="Icon"
                      boxSize={4}
                      mr={1}
                    />
                    Reload Video
                  </Flex>

                  <Flex
                    bg="#ED837F"
                    className="items-center justify-center rounded-md"
                    color={'white'}
                    fontWeight={400}
                    _hover={{
                      backgroundColor: '#ED837F',
                      color: 'white',
                    }}
                    py={1}
                    px={4}
                  >
                    {' '}
                    Skip Ad
                    <Image
                      src={'/rewards/playbtn.svg'}
                      alt="Icon"
                      boxSize={3}
                      ml={1}
                    />
                  </Flex>
                </Flex>

                <Image
                  src="/rewards/compare.svg"
                  alt="compare"
                  boxSize={{ base: 4, sm: 5 }}
                  alignSelf={'center'}
                />

                <Text className="my-3 text-center text-2xl font-semibold text-[#656565]">
                  $0.00
                </Text>
                <Text className="text-center text-[16px] text-[#656565]">
                  Keep in mind, if you{' '}
                  <span className="font-bold">skip ads</span> or{' '}
                  <span className="font-bold">replay videos</span>, that
                  watchtime will{' '}
                  <span className="font-bold">not be counted</span> towards your
                  Watch Time Earnings.
                </Text>
              </Flex>

              <Flex className="absolute bottom-[4%] w-full flex-col gap-3 px-4">
                <Button
                  className="w-full py-2 font-semibold"
                  color={'white'}
                  bg={'lyk-green'}
                  border="2px solid white"
                  _hover={{
                    border: '2px solid white',
                  }}
                  onClick={handleCloseMobileModal}
                >
                  Go Back
                </Button>
              </Flex>
            </ModalBody>
          </ModalContent>
        </Modal>
      </Box>
    </>
  )
}
